import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { removeCartItem } from '../../Redux/features/Cart/CartSlice'
import { ConfigContext } from '../../Context/ConfigContext'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { formatSlug } from '../../Utils/Helper'

const HeaderBottom = () => {
    const cartList = useSelector(state => state.Cart)
    const wishList = useSelector(state => state.Wishlist)
    const dispatch = useDispatch()
    const [subTotalAmount, setSubTotalAmount] = useState(0)
    const { apiURL, currency } = useContext(ConfigContext)
    const [data, setData] = useState([])
    const [leftdata, setleftdata] = useState([])
    const [rightdata, setrightdata] = useState([])
    const [leftmoredata, setleftmoredata] = useState([])
    const [rightmoredata, setrightmoredata] = useState([])

    const GetCategories = async () => {
        const response = await axios.get(`${apiURL}Home/GetCategories`)
        setData(response.data.data);
        SpliteData(response.data.data);
    }


    const SpliteData = (AllData) => {

        const left = [];
        const leftmore = [];
        const right = [];
        const rightmore = [];

        for (let i = 0; i < 14; i++) {
            if (AllData[i]) {

                if (i < 5) {
                    left.push(AllData[i]);
                }
                if (i > 5 && i < 7) {
                    leftmore.push(AllData[i]);
                }

                if (i > 7 && i < 12) {
                    right.push(AllData[i]);
                }
                if (i > 12 && i < 14) {
                    rightmore.push(AllData[i]);
                }
            }
        }

        setleftdata(left);
        setrightdata(right);
        setleftmoredata(leftmore);
        setrightmoredata(rightmore);
    }

    const calculatesubTotalAmount = () => {
        const subTotal = cartList.reduce((acc, cur) => acc + cur.quantity * cur.product_variant_sale_price, 0)
        setSubTotalAmount(subTotal)
    }

    useEffect(() => {
        GetCategories();
    }, []);

    useEffect(() => {
        calculatesubTotalAmount();
    }, [cartList]);


    return (
        <>
            <div className="container">
                <div className="header-wrap header-space-between position-relative">
                    {/* <div className="logo logo-width-1" style={{ marginTop: "4px" }}>
                        <Link to="/"><img src="/assets/imgs/logo/6.png" alt="logo" /></Link>
                    </div> */}
                    <div className="logo logo-width-1 d-block d-lg-none" style={{ marginTop: "4px" }}>
                        <Link to="/"><img src="/assets/imgs/logo/2.png" alt="logo" style={{ width: "250px" }} /></Link>
                    </div>

                    <div className="header-nav d-none d-lg-flex">
                        <div className="main-categori-wrap d-none d-lg-block">
                            <div className="categories-dropdown-wrap categories-dropdown-active-large font-heading">
                                <div className="d-flex categori-dropdown-inner">
                                    <ul>
                                        {
                                            leftdata.map((item) => {
                                                return (

                                                    <li key={item.category_id}>
                                                        <Link> <img src={item.category_image_url} alt />{item.category_title}</Link>
                                                    </li>
                                                )
                                            })}
                                    </ul>
                                    <ul className="end">
                                        {rightdata.map((item) => {
                                            return (

                                                <li key={item.category_id}>
                                                    <Link> <img src={item.category_image_url} alt />{item.category_title}</Link>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                                <div className="more_slide_open" style={{ display: 'none' }}>
                                    <div className="d-flex categori-dropdown-inner">
                                        <ul>
                                            {leftmoredata.map((item) => {
                                                return (

                                                    <li key={item.category_id}>
                                                        <Link> <img src={item.category_image_url} alt />{item.category_title}</Link>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                        <ul className="end">
                                            {rightmoredata.map((item) => {
                                                return (

                                                    <li key={item.category_id}>
                                                        <Link> <img src={item.category_image_url} alt />{item.category_title}</Link>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                <div className="more_categories"><span className="icon" /> <span className="heading-sm-1">Show more...</span></div>
                            </div>
                        </div>
                        <div className="main-menu main-menu-padding-1 main-menu-lh-2 d-none d-lg-block font-heading">
                            <nav>
                                <ul>
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    {
                                        data.map((item) => {
                                            return (
                                                <li key={item.category_id}>
                                                    <Link to={`/AllProductsList/${formatSlug(item.category_title)}=${item.category_id}`}>{item.category_title}
                                                        {
                                                            item.children.length !== 0 &&
                                                            <i className="fi-rs-angle-down" />
                                                        } </Link>
                                                    {item.children.length > 0 ? <>
                                                        <ul className="sub-menu">
                                                            {
                                                                item.children.map((subItem) => {
                                                                    return (
                                                                        <li key={subItem.category_id}>
                                                                            <Link to={`/AllProductsList/${formatSlug(subItem.category_title)}=${subItem.category_id}`}>{subItem.category_title}
                                                                                {
                                                                                    subItem.children.length !== 0 ?
                                                                                        < i className="fi-rs-angle-right" />
                                                                                        : ""
                                                                                }
                                                                            </Link>
                                                                            {
                                                                                subItem.children.length > 0 ? <>
                                                                                    <ul className="level-menu">
                                                                                        {
                                                                                            subItem.children.map((subMenuItem) => {
                                                                                                return (
                                                                                                    <>
                                                                                                        <li
                                                                                                            key={subMenuItem.category_id}
                                                                                                        >
                                                                                                            <Link to={`/AllProductsList/${formatSlug(subMenuItem.category_title)}=${subMenuItem.category_id}`}>
                                                                                                                {subMenuItem.category_title}
                                                                                                            </Link>
                                                                                                        </li>
                                                                                                    </>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </ul>
                                                                                </> : ""
                                                                            }
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </ul>
                                                    </> : ""}
                                                </li>
                                            )
                                        })
                                    }

                                    <li>
                                        <Link to={'/Contact'}>Contact</Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div className="hotline d-none d-lg-flex">
                        <img src="/assets/imgs/theme/icons/icon-headphone.svg" alt="hotline" />
                        <p> <Link to={'tel:+91 9049045886'}>+91 9049045886</Link> <span>24/7 SupportCenters</span></p>
                    </div>
                    <div className="header-action-icon-2 d-block d-lg-none">
                        <div className="burger-icon burger-icon-white">
                            <span className="burger-icon-top" />
                            <span className="burger-icon-mid" />
                            <span className="burger-icon-bottom" />
                        </div>
                    </div>
                    <div className="header-action-right d-block d-lg-none">
                        <div className="header-action-2">
                            <div className="header-action-icon-2">
                                <Link to="/WishList">
                                    <img alt="Nest" src="/assets/imgs/theme/icons/icon-heart.svg" />
                                    <span className="pro-count white">{wishList.length}</span>
                                </Link>
                            </div>
                            <div className="header-action-icon-2">
                                <Link className="mini-cart-icon" to="/AddToCart">
                                    <img src="/assets/imgs/theme/icons/icon-cart.svg" />
                                    <span className="pro-count white">{cartList.length}</span>
                                </Link>
                                <div className="cart-dropdown-wrap cart-dropdown-hm2">
                                    <ul>
                                        {cartList.map((item) => (
                                            <li>
                                                <div className="shopping-cart-img">
                                                    <Link><img src={item.product_image_url} /></Link>
                                                </div>
                                                <div className="shopping-cart-title">
                                                    <h4><Link>{item.product_title}</Link></h4>
                                                    <h4><span>{item.quantity} × </span>{currency} {item.product_variant_sale_price}</h4>
                                                </div>
                                                <div className="shopping-cart-delete">
                                                    <span style={{ cursor: "pointer" }} onClick={() => dispatch(removeCartItem(item.product_id))}><i className="fi-rs-cross-small" /></span>
                                                </div>
                                            </li>
                                        ))
                                        }
                                    </ul>
                                    <div className="shopping-cart-footer">
                                        <div className="shopping-cart-total">
                                            <h4>Total : <span> {currency} {subTotalAmount}</span></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeaderBottom